import { createSelector, Selector } from 'reselect';
import { getUserState, State } from '../../reducers';

export const selectIsPasswordChanging: Selector<State, boolean> = createSelector(
  [getUserState],
  (userState) => userState.sessionState === 'CHANGING_PASSWORD'
);
